const buildCookieString = (name, value, options = {}) => {
  const {
    path,
    expires,
    httpOnly,
    sameSite,
    domain,
    maxAge
  } = options;
  const secure = process.env.NODE_ENV !== "development" && options.secure;
  const parsedValue = typeof value === "object" ? JSON.stringify(value) : value;
  const cookieString = `${name}=${parsedValue}; path=${path ?? "/"}; ${expires && !maxAge ? `expires=${expires.toUTCString()};` : ""} ${secure ? "secure;" : ""} ${httpOnly ? "httpOnly;" : ""} ${sameSite ? `sameSite=${sameSite};` : ""} ${domain ? `domain=${domain};` : ""} ${maxAge ? `max-age=${maxAge};` : ""}`;
  return cookieString.replace(/;+$/, "").replace(/\n+/g, "");
};
const getCookies = (cookieString) => {
  return cookieString.split(";").map((cookie) => cookie.trim()).map((cookie) => {
    const [name, ...value] = cookie.split("=");
    return {
      name,
      value: value.join("="),
      options: {}
    };
  });
};
const getCookie = (cookieString, name) => {
  return getCookies(cookieString).find((cookie) => cookie.name === name);
};
const deleteAllCookies = () => {
  const cookies = getCookies(document.cookie);
  cookies.forEach((cookie) => {
    document.cookie = buildCookieString(cookie.name, "", {
      expires: /* @__PURE__ */ new Date(0)
    });
  });
};

export { buildCookieString, deleteAllCookies, getCookie };
//# sourceMappingURL=index.js.map
